<ng-container *transloco="let t">
  <!-- Shipping Options -->
  @let shippingOption = selectedShippingOption();

  <pxw-input-radio-group
    class="shipping-options"
    name="shippingOption"
    [label]="t('endOrder.shippingOptionLabel')"
    [helper]="restrictionHint() ?? ''"
    [options]="shippingOptionTypes()"
    [(ngModel)]="shippingOptionType"
    required
    [displayErrors]="isFormSubmitted()"
    [messages]="{
      required: t('endOrder.shippingOptionRequired'),
    }"
    layout="inline"
  >
    <ng-template #radioItemTemplate let-shippingOptionType>
      {{ t('endOrder.shippingOption_' + shippingOptionType) }}
    </ng-template>
  </pxw-input-radio-group>

  @if (shippingOption) {
    @if (subsidiarySelectorEnabled()) {
      <div class="ui-input">
        <div class="subsidiaries-label-wrapper">
          <label class="ui-label ui-label--required">
            {{ t('endOrder.subsidiarySelectorLabel') }}
          </label>
          @if (selectedGroupSubsidiaries().length > 1) {
            <pxw-button
              appareance="link"
              color="link"
              size="sm"
              [rounded]="true"
              (click)="openSubsidiariesSelector.emit()"
            >
              <pxw-icon icon="map-marker" />
              {{ t('endOrder.openSubsidiarySelectorDialog') }}
            </pxw-button>
          }
        </div>
        <pxw-select-box
          name="subsidiarySelector"
          [helper]="selectedSubsidiaryAddress() || t('endOrder.subsidiarySelectorHelper')"
          [(ngModel)]="selectedSubsidiaryIdLinked"
          (ngModelChange)="onManuallySelectedSubsidiary($event)"
          [options]="selectedGroupSubsidiaries()"
          [labelKey]="'name'"
          [valueKey]="'id'"
          [displayErrors]="isFormSubmitted()"
          required
          [messages]="{ required: t('validation.required') }"
        >
          <ng-template #optionItemTemplate let-subsidiary>
            <ng-container
              *ngTemplateOutlet="subsidiaryItemTemplate; context: { $implicit: subsidiary }"
            />
          </ng-template>
        </pxw-select-box>
      </div>
    }
    @if (shippingOption.type === typesOfShippings.IN_PLACE) {
      <pxw-input-text
        name="tableNumber"
        [label]="t('endOrder.tableNumberLabel')"
        [placeholder]="t('endOrder.tableNumberPlaceholder')"
        [(ngModel)]="tableNumber"
        [displayErrors]="isFormSubmitted()"
        required
        [messages]="{ required: t('endOrder.tableNumberRequired') }"
      />
    }

    @if (
      shippingOption.type === typesOfShippings.DELIVERY ||
      shippingOption.type === typesOfShippings.PARCEL
    ) {
      <pxw-address
        [workerServicesUrl]="workerServicesUrl()"
        [isFormSubmitted]="isFormSubmitted()"
        [(address)]="address"
        [disableAddressInMap]="shippingOption['disableAddressInMap'] || false"
        [countryCodes]="countryCodes()"
        [shippingCostResponse]="shippingCostResponse()"
        [selectedParcelOption]="selectedParcelOption()"
        [checkoutData]="checkoutData()"
        (selectedParcelOptionChange)="onParcelOptionSelected($event)"
      >
        @if (showDeliverySubsidiarySelector()) {
          <div class="ui-input">
            <label class="ui-label ui-label--required">
              {{ t('endOrder.subsidiarySelectorLabel') }}
            </label>
            <pxw-select-box
              name="deliverySubsidiarySelector"
              [helper]="selectedSubsidiaryAddress() || t('endOrder.subsidiarySelectorHelper')"
              [(ngModel)]="selectedSubsidiaryIdLinked"
              (ngModelChange)="onDeliverySubsidiarySelected($event)"
              [options]="deliverySubsidiaryOptions()"
              [labelKey]="'name'"
              [valueKey]="'id'"
              [displayErrors]="isFormSubmitted()"
              required
              [messages]="{ required: t('validation.required') }"
            >
              <ng-template #optionItemTemplate let-subsidiary>
                <ng-container
                  *ngTemplateOutlet="subsidiaryItemTemplate; context: { $implicit: subsidiary }"
                />
              </ng-template>
            </pxw-select-box>
          </div>
        }
        @if (checkingShippingCoverage()) {
          <pxw-shipping-calculation [isFormSubmitted]="isFormSubmitted()" />
        } @else if (shippingCoverageError() === 'not-found') {
          <pxw-shipping-not-allowed
            [isFormSubmitted]="isFormSubmitted()"
            [message]="t('shippingCostResponse.outOfDeliveryZoneAlert')"
          />
        } @else if (shippingCoverageError() === 'unknown-error') {
          <pxw-shipping-not-allowed
            [isFormSubmitted]="isFormSubmitted()"
            [message]="t('shippingCostResponse.coverageUnknownError')"
          />
        } @else if (shippingEnabled()) {
          <pxw-shipping-cost-response
            style="margin-bottom: 1.5em"
            [isFormSubmitted]="isFormSubmitted()"
            [apiUrl]="apiUrl()"
            [establishment]="establishment()"
            [(shippingCostResponse)]="shippingCostResponse"
            [(calculatingShippingCost)]="calculatingShippingCost"
            [address]="address()"
            [name]="name()"
            [phone]="phone()"
            [cartItems]="cartItems()"
            [totalAmountWithDiscount]="totalAmountWithDiscount()"
            [previousShippingEstimate]="previousShippingEstimate()"
            [availableLogisticIntegrations]="availableLogisticIntegrations()"
            [selectedParcelOption]="selectedParcelOption()"
            [checkoutData]="checkoutData()"
            (selectedParcelOptionChange)="onParcelOptionSelected($event)"
            (selectedBranchChange)="onBranchSelected($event)"
          />
        }
      </pxw-address>
    }
  }
</ng-container>
<ng-template #subsidiaryItemTemplate let-subsidiary>
  <div class="subsidiary-selector__item">
    <strong class="subsidiary-selector__name">{{ subsidiary.name }}</strong>
    <pxw-establishment-opened-status-tag
      class="subsidiary-selector__status"
      [establishment]="subsidiary"
    />
    <small class="subsidiary-selector__address">
      {{ subsidiary.address || subsidiary?.addressDetails?.fullAddress }}
    </small>
  </div>
</ng-template>
